import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import React, { useState, useEffect } from 'react'
import {changeDecision, getStandardRemarkList} from '../../utils/API'
import Autocomplete from '@mui/material/Autocomplete'

const ChangeDecision = ({ claimId, claimNumber, adjudicationStatus }) => {
    const statusMap = {
        "Initial Authorized": "approved",
        "Interim Authorized": "approved",
        "Discharge Authorized": "approved",
        "APPROVED": "approved",

        "Denied": "denied",

        "Query Raised-Initial Pre-Authorzation": "query",
        "Query Raised-Interim Pre-Authorzation": "query",
        "Query Raised-Discharge Pre-Authorzation": "query",

        "Out of scope policy": "fail",
        "Out of scope procedure": "fail",
        "Out of scope hospital": "fail",
        "Relevant document not found": "fail",
        "FAILED": "fail",
    }

    const [showChangeDecisionDialog, setShowChangeDecisionDialog] = useState(false)
    const [remarks, setRemarks] = useState('')
    const [decision, setDecision] = useState('approve')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState(false)
    const [options, setOptions] = useState([])
    const [selectedOption, setSelectedOption] = useState([])
    const [customOption, setCustomOption] = useState('')



    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await getStandardRemarkList();
                const optionList = response?.data?.filter(item => item.active).map(item => item.remark) || [];
                setOptions(optionList);
            } catch (error) {
                console.error("Error fetching options:", error);
            }
        };
        fetchOptions();
    }, []);

    const openChangeDescionDialogBox = () => setShowChangeDecisionDialog(true)
    const closeChangeDescionDialogBox = () => {
        setShowChangeDecisionDialog(false)
        setCustomOption('')
    }

    const handleSubmit = async () => {
        setIsSubmitting(true)
        if (remarks.length === 0) {
            setError(true)
            setIsSubmitting(false)
            return
        }
        await changeDecision({
            claimNumber,
            claimDataId: claimId,
            status: decision,
            remarks,
        })
        setIsSubmitting(false)
        closeChangeDescionDialogBox()
    }

    return (
        <Box>
            <Button
                variant="contained"
                color="primary"
                onClick={openChangeDescionDialogBox}
                sx={{ mt: '1rem' }}
            >
                Change Decision
            </Button>
            <Dialog
                open={showChangeDecisionDialog}
                onClose={closeChangeDescionDialogBox}
            >
                <DialogTitle>Change Decision</DialogTitle>
                <DialogContent sx={{
                    width: '30rem',
                    height: '15rem',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Decision</InputLabel>
                        <Select
                            value={decision}
                            label="Decision"
                            onChange={(e) => setDecision(e.target.value)}
                        >
                            <MenuItem disabled={statusMap[adjudicationStatus] === "approved"} value={'approved'}>Approve</MenuItem>
                            <MenuItem disabled={statusMap[adjudicationStatus] === "denied"} value={'denied'}>Deny</MenuItem>
                            <MenuItem disabled={statusMap[adjudicationStatus] === "query"} value={'query'}>Query</MenuItem>
                            <MenuItem disabled={statusMap[adjudicationStatus] === "fail"} value={'fail'}>Fail</MenuItem>
                        </Select>
                    </FormControl>
                    <Autocomplete
                        multiple
                        options={[...options]}
                        getOptionLabel={(option) => option}
                        value={selectedOption}
                        onChange={(event, newValue) => {
                            setSelectedOption(newValue)
                            setRemarks(newValue.join(", "));
                        }
                    }
                        renderInput={(params) => <TextField {...params} label="Remarks" variant="outlined" fullWidth />}
                        sx={{ mb: 2, width: '100%' }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button disabled={isSubmitting} onClick={closeChangeDescionDialogBox}>Cancel</Button>
                    <Button disabled={isSubmitting} onClick={handleSubmit}>Submit</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default ChangeDecision
